import React from 'react';

export const LockIcon = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export const ChevronLeft = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const ChevronRight = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const VideoIcon = ({ active }) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    {active
      ? <><polygon points="23 7 16 12 23 17 23 7" /><rect x="1" y="5" width="15" height="14" rx="2" /></>
      : <><line x1="1" y1="1" x2="23" y2="23" /><path d="M15 13a3 3 0 0 1-3 3H7a2 2 0 0 1-2-2V7m4 0h6l4-4v11" /></>
    }
  </svg>
);

export const MicIcon = ({ active }) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    {active
      ? <><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" /><path d="M19 10v2a7 7 0 0 1-14 0v-2" /><line x1="12" y1="19" x2="12" y2="23" /><line x1="8" y1="23" x2="16" y2="23" /></>
      : <><line x1="1" y1="1" x2="23" y2="23" /><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6" /><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23" /><line x1="12" y1="19" x2="12" y2="23" /><line x1="8" y1="23" x2="16" y2="23" /></>
    }
  </svg>
);

export const ChatIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

export const AISparkIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z" />
  </svg>
);

export const SendIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" fill="currentColor" stroke="none" />
  </svg>
);

export const CheckIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const PdfIcon = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

// ── App Constants ─────────────────────────────────────────────────────────────

export const API_BASE = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5000');

export const SECTIONS = [
  { id: 'panchanga',    label: 'Panchanga',       emoji: '☀',  color: '#4FC3F7' },
  { id: 'personality',  label: 'Personality',     emoji: '☯',  color: '#D4AF37' },
  { id: 'moles',        label: 'Moles & Palm',    emoji: '✋',  color: '#FF8A65' },
  { id: 'childhood',    label: 'Childhood',       emoji: '🌱',  color: '#81C784' },
  { id: 'teenage',      label: 'Teenage',         emoji: '📚',  color: '#AED581' },
  { id: 'youngAdult',   label: 'Young Adult',     emoji: '🌳',  color: '#E6EE9C' },
  { id: 'loveMarriage', label: 'Love & Marriage', emoji: '💖',  color: '#F48FB1' },
  { id: 'career',       label: 'Career',          emoji: '⭐',  color: '#FFD54F' },
  { id: 'recentYears',  label: 'Recent Years',    emoji: '🌙',  color: '#CE93D8' },
  { id: 'overall',      label: 'Overall Life',    emoji: '✨',  color: '#80CBC4' },
  { id: 'future',       label: 'Future',          emoji: '🔮',  color: '#FFF176', locked: true },
];

export const QUICK_QUESTIONS = [
  'What events happened in this dasha?',
  'What is the spouse prediction?',
  'Any health issues in this phase?',
  'What remedies to suggest?',
];

export const DEMO_BIRTH = {
  name: 'Demo Chart', gender: 'Male', place: 'Hyderabad, India',
  day: 15, month: 6, year: 1990,
  hour: 10, min: 30,
  lat: 17.3850, lon: 78.4867, tzone: 5.5,
};
